import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const defaultDateTimeFormat = 'MM[-]DD[-]YYYY hh:mm a'; // 04/11/22 02:49 PM
export const defaultDateFormat = 'MM[-]DD[-]YYYY'; // 04/11/22
export const readableDateTimeFormat = 'LLLL'; // Monday, April 11, 2022 2:49 PM
export const readableDateFormat = 'dddd[,] MMMM DD[,] YYYY'; // Monday, April 11, 2022
export enum EnvironmentType {
    Dev,
    Prod
}
export let environment:EnvironmentType;



let ircGoogleClientID;
let googleAnalytics4IdString;

const msalConfig = {
     auth: {
         clientId: '04b09a10-132f-4099-9344-6a5353fbcb61', // This is the ONLY mandatory field that you need to supply.
         authority: 'https://login.microsoftonline.com/6c914e68-b62c-4d70-87e8-e80fa76971f4', // Replace the placeholder with your tenant info
         redirectUri: window.location.origin, // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
         postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
         navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
     },
     cache: {
         cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
     },
     system: {
         loggerOptions: {
             loggerCallback: (level, message, containsPii) => {
                 if (containsPii) {
                     return;
                 }
                 switch (level) {
                     case LogLevel.Error:
                         console.error(message);
                         return;
                     case LogLevel.Info:
                         console.info(message);
                         return;
                     case LogLevel.Verbose:
                         console.debug(message);
                         return;
                     case LogLevel.Warning:
                         console.warn(message);
                         return;
                     default:
                         return;
                 }
             },
         },
     },
 };

 /**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};



const hostname = window && window.location && window.location.hostname;

// Modify Entra Client ID based on environment
if(hostname === `localhost` || hostname === `d125-irc-dev-app-byc0gbgshha4ghde.a03.azurefd.net`){
    msalConfig.auth.clientId = `04b09a10-132f-4099-9344-6a5353fbcb61`; // Dev Environment

} else if (hostname === `d125-qa-app.azurewebsites.net` || hostname === `d125-irc-qa-app-dbhpdnggg3bahrb2.a03.azurefd.net`){
    msalConfig.auth.clientId = `ef8c9d8c-5fe4-47a3-a5b0-1f34416c72bf`; // Qa Environment

} else if (hostname === `irc.d125.org` || hostname === `d125-irc-prod-app-fze0cyggcedjgyc6.a03.azurefd.net` || hostname === `d125-irc2-test.azurewebsites.net`){
    msalConfig.auth.clientId = `39b3a8ce-e28a-4059-aec7-d1a626f6644d`; // Prod Environment

} else {
    throw new Error(`Environment not implemented: ${hostname}`);
}   




if (hostname === `localhost` ||
    hostname === `d125-irc2-test.azurewebsites.net` ||
    // hostname === `d125-test-app.azurewebsites.net` ||
    hostname === `d125-qa-app.azurewebsites.net` ||
    hostname === `d125-irc-qa-app-dbhpdnggg3bahrb2.a03.azurefd.net` ||
    hostname === `d125-irc-dev-app-byc0gbgshha4ghde.a03.azurefd.net`
    ) {
    // Localhost / Dev environment config
    ircGoogleClientID = `231991343782-ifa4fd1up22o24llhmv7lnc5droo2q8v`;
    environment = EnvironmentType.Dev;
    //Stevenson IRC Data stream - QA
    googleAnalytics4IdString = "G-4XV14FK5QP";

} else if (
    hostname === `irc.d125.org` ||
    hostname === `d125-irc-prod-app-fze0cyggcedjgyc6.a03.azurefd.net`

) {
    // PROD environment config
    ircGoogleClientID = `231991343782-ifa4fd1up22o24llhmv7lnc5droo2q8v`;
    environment = EnvironmentType.Prod;
    // Stevenson IRC Data stream - Prod
    googleAnalytics4IdString = "G-EESM6KSJJX";
} else if (!hostname) {
    // Unit Testing environment
} else {
    throw new Error(`Environment not implemented: ${hostname}`);
}

export const googleAnalytics4Id = googleAnalytics4IdString;
export const googleClientId = ircGoogleClientID + `.apps.googleusercontent.com`;

export const msalInstance = new PublicClientApplication(msalConfig);